/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-09-16 15:37:32
 */

import type { Dayjs } from 'dayjs'
import CONFIG from '../../../constants/config'
import { DepartmentMemberV2, DepartmentV2 } from '../../../global'

export const formatTitlesData = (titlesData) => {
  return titlesData.reduce((prev, cur) => {
    for (const item of prev) {
      if (cur.titleName === item.titleName) {
        item.titleId = item.titleId + ',' + cur.titleId
        return prev
      }
    }
    prev.push(cur)
    return prev
  }, [])
}

// export const setTitleListData = (data) => {
//   data.titles.sort((a, b) => {
//     if (a.titleName === b.titleName) {
//       return a.titleId.localeCompare(b.titleId)
//     }
//     return a.titleName.localeCompare(b.titleName)
//   })
//   let result = formatTitlesData(data.titles)
//   return result
// }

export const calcPickedMemberNum = (filter, members) => {
  const departments = filter.departments || []
  const departmentUsers = filter.departmentUsers || []
  const userNumInDepartments = departments
    .map((department) => department.num || 0)
    .reduce((acc, cur) => acc + cur, 0)
  const total = departmentUsers.length + userNumInDepartments
  if (
    total === 0 ||
    total === members.length ||
    departments.some((department) => department.id === '0')
  ) {
    return members.length
  } else {
    return total
  }
}

export const sensorsClassification = (folderRule) => {
  return folderRule === 'customize'
    ? 'custom'
    : folderRule === 'date'
      ? 'date'
      : folderRule === 'user'
        ? 'member'
        : 'notClassification'
}

export const sensorsNamingMethod = (namingRule) => {
  return namingRule.map((rule) => {
    if (rule.includes('title')) {
      return rule.split('title:')[1]
    } else if (rule.includes('diy')) {
      return '自定义标签'
    } else {
      switch (rule) {
        case 'user':
          return '拍摄人姓名'
        case 'time':
          return '拍摄时间'
        case 'address':
          return '拍摄地点'
        case 'watermark':
          return '水印模板'
        case 'photoNumber':
          return '照片编号'
        default:
          return ''
      }
    }
  })
}

export const calcCheckedPhotoNum = (photoState) => {
  const checkedPhotos = photoState.checkedPhotos
  const unCheckedPhotos = photoState.unCheckedPhotos
  const photosNum = photoState.photosNum
  const checkAll = photoState.checkAll
  if (checkAll) {
    return photosNum - Object.keys(unCheckedPhotos).length
  } else {
    return Object.keys(checkedPhotos).length
  }
}

type QueryFilter = {
  departments?: DepartmentV2[]
  departmentUsers?: DepartmentMemberV2[]
  members?: string[]
  searchKeywords?: string[]
  mediaType?: string | number | null
  sourceType?: string | number | null
  times?: [Dayjs, Dayjs] | any[]
  watermarks?: string[]
  locations?: any[]
  useSynonym?: boolean
  useSegment?: boolean
  // 0416web高级推荐版本，新增推荐词，新增suggestedSearchWords与useSuggestedSearch字段（推荐词列表）
  useSuggestedSearch?: boolean
  suggestedSearchWords?: {
    word: string
    source: string
    isChecked: boolean
  }[]
  existWatermark?: number
  labelIDs?: string[]
  labelMatchAll?: boolean
  untaggedOnly?: boolean
}

type LocationRecommend = {
  word: string
  key: string
}

/**
 * 构造查询照片接口参数，将【进入全部照片页首次查询】、【筛选】、【显隐相近词】、【滚动加载更多】等操作的参数构造统一
 * @param queryFilter 查询条件，区别于filter
 * @param groupID
 * @param lastPageCond
 * @returns
 */
export const buildFetchPhotosParams = (
  queryFilter: QueryFilter,
  groupID: string,
  lastPageCond = ''
) => {
  const departments = queryFilter.departments || []
  const departmentUsers = queryFilter.departmentUsers || []
  const watermarks = queryFilter.watermarks || []
  const times = queryFilter.times || []
  const departmentIDList = departments.map((department) => department.id)
  const userIDList = departmentUsers.map((user) => user.userID)
  return {
    filter: {
      // 如果是地点关键词搜索，不含其他关键词
      searchKeywords: queryFilter.searchKeywords, //多关键词
      mediaType: queryFilter.mediaType,
      sourceType: queryFilter.sourceType,
      times: [
        {
          start: (times[0] as Dayjs)?.format(CONFIG.timeFormat),
          end: (times[1] as Dayjs)?.format(CONFIG.timeFormat)
        }
      ],
      userIDList: userIDList, //NEW
      departmentIDList: departmentIDList, //NEW
      watermarks: watermarks.map((watermark) => ({
        watermarkBaseID: watermark.split('+')[0],
        groupWatermarkID: watermark.split('+')[1]
      })),
      locations: queryFilter.locations,
      useSegment: queryFilter.useSegment,
      // 0416web高级推荐版本，新增推荐词，useSynonym需要传false
      // useSynonym: queryFilter.useSynonym,
      useSynonym: false,
      // 0416web高级推荐版本，新增推荐词，新增suggestedSearchWords与useSuggestedSearch字段（推荐词列表）
      useSuggestedSearch: true,
      suggestedSearchWords: queryFilter.suggestedSearchWords,
      labelIDs: queryFilter.untaggedOnly ? [] : queryFilter.labelIDs || [],
      labelMatchAll: queryFilter.untaggedOnly
        ? false
        : Boolean(queryFilter.labelMatchAll),
      untaggedOnly: Boolean(queryFilter.untaggedOnly)
    },
    groupID,
    lastPageCond
  }
}

type PlainQueryFilter = {
  departments?: DepartmentV2[]
  departmentUsers?: DepartmentMemberV2[]
  members?: string[]
  searchKeywords?: string[]
  mediaType?: string | number | null
  sourceType?: string | number | null
  times?: [Dayjs, Dayjs] | any[]
  watermarks?: string[]
  locations?: any[]
  useSynonym?: boolean
  useSegment?: boolean
  // 0416web高级推荐版本，新增推荐词，新增suggestedSearchWords与useSuggestedSearch字段（推荐词列表）
  useSuggestedSearch?: boolean
  suggestedSearchWords?: {
    word: string
    source: string
    isChecked: boolean
  }[]
  existWatermark?: number
  labelIDs?: string[]
  labelMatchAll?: boolean
  untaggedOnly?: boolean
}

type FetchPhotosParams = {
  /** 查询过滤条件,包含部门、成员、关键词、媒体类型等 */
  queryFilter: PlainQueryFilter | null
  /** 团队ID */
  groupID: string
  /** 分页标记,用于加载更多照片 */
  lastPageCond: string
  /** 位置推荐信息,用于位置搜索模式 */
  locationRecommend?: LocationRecommend | null
  /** 是否按位置搜索 */
  byLocation?: boolean
  /** 是否为精确搜索模式 */
  isPreciseSearch?: boolean
  /** 精准搜索需要排除的关键词列表 */
  excludeKeywords?: string[]
  /** 是否为升序排序 */
  isAscSort?: boolean
}

/**
 * 构建获取照片、批量操作的参数，支持多种选项配置
 * 支持普通搜索、位置搜索和精确搜索三种模式
 * @param options 搜索参数选项
 * @param options.queryFilter 查询过滤条件，包含部门、成员、关键词、媒体类型等
 * @param options.groupID 团队ID
 * @param options.lastPageCond 分页标记，用于加载更多照片
 * @param options.locationRecommend 位置推荐信息，用于位置搜索模式
 * @param options.byLocation 是否按位置搜索
 * @param options.isPreciseSearch 是否为精确搜索模式
 * @param options.excludeKeywords 精准搜索需要排除的关键词列表
 * @returns 格式化后的请求参数对象
 */
export const buildFetchPhotosParamsWithOptions = (
  options: FetchPhotosParams
) => {
  const {
    queryFilter,
    groupID,
    lastPageCond = '',
    locationRecommend = null,
    byLocation = false,
    isPreciseSearch = false,
    excludeKeywords = [],
    isAscSort = false
  } = options
  // 处理 queryFilter 为 null 的情况，使用空对象作为默认值
  const safeQueryFilter = queryFilter || {}
  const departments = safeQueryFilter.departments || []
  const departmentUsers = safeQueryFilter.departmentUsers || []
  const watermarks = safeQueryFilter.watermarks || []
  const times = safeQueryFilter.times || []
  const searchKeywords = safeQueryFilter.searchKeywords || []
  const departmentIDList = departments.map((department) => department.id)
  const userIDList = departmentUsers.map((user) => user.userID)
  return {
    filter: {
      // 如果是地点关键词搜索，不含其他关键词
      searchKeywords: byLocation ? [] : searchKeywords, //多关键词
      mediaType: safeQueryFilter.mediaType,
      sourceType: safeQueryFilter.sourceType,
      times: [
        {
          start: (times[0] as Dayjs)?.format(CONFIG.timeFormat),
          end: (times[1] as Dayjs)?.format(CONFIG.timeFormat)
        }
      ],
      userIDList: userIDList, //NEW
      departmentIDList: departmentIDList, //NEW
      watermarks: watermarks.map((watermark) => ({
        watermarkBaseID: watermark.split('+')[0],
        groupWatermarkID: watermark.split('+')[1]
      })),
      locations: safeQueryFilter.locations,
      useSegment: safeQueryFilter.useSegment,
      // 0416web高级推荐版本，新增推荐词，useSynonym需要传false
      // useSynonym: safeQueryFilter.useSynonym,
      useSynonym: false,
      // 0416web高级推荐版本，新增推荐词，新增suggestedSearchWords与useSuggestedSearch字段（推荐词列表）
      useSuggestedSearch: byLocation ? false : true,
      suggestedSearchWords: byLocation
        ? []
        : safeQueryFilter.suggestedSearchWords,
      // 如果是地点关键词搜索，包含地点关键词
      locationRecommend: byLocation
        ? locationRecommend || {
            word: searchKeywords[0]
          }
        : {},
      excludeKeywords, //  230新增，精准搜索排除关键词，对照片进行批量操作时使用
      existWatermark: safeQueryFilter.existWatermark, // 295新增含水印筛选字段
      labelIDs: safeQueryFilter.untaggedOnly
        ? []
        : safeQueryFilter.labelIDs || [],
      labelMatchAll: safeQueryFilter.untaggedOnly
        ? false
        : Boolean(safeQueryFilter.labelMatchAll),
      untaggedOnly: Boolean(safeQueryFilter.untaggedOnly)
    },
    isPreciseSearch, // 230新增，精准搜索， 是否是精准搜索照片
    isAscSort, // 265新增，排序
    groupID,
    lastPageCond
  }
}
